/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionRemotePatientSearchFieldMap
 */
export interface PalAuthSubmissionRemotePatientSearchFieldMap {
    /**
     * 
     */
    member_number?: string;
    /**
     * 
     */
    member_last_name?: string;
    /**
     * 
     */
    member_first_name?: string;
    /**
     * 
     */
    member_dob?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionRemotePatientSearchFieldMap interface.
 */
export function instanceOfPalAuthSubmissionRemotePatientSearchFieldMap(value: object): value is PalAuthSubmissionRemotePatientSearchFieldMap {
    return true;
}

export function PalAuthSubmissionRemotePatientSearchFieldMapFromJSON(json: any): PalAuthSubmissionRemotePatientSearchFieldMap {
    return PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionRemotePatientSearchFieldMap {
    if (json == null) {
        return json;
    }
    return {
        
        'member_number': json['member_number'] == null ? undefined : json['member_number'],
        'member_last_name': json['member_last_name'] == null ? undefined : json['member_last_name'],
        'member_first_name': json['member_first_name'] == null ? undefined : json['member_first_name'],
        'member_dob': json['member_dob'] == null ? undefined : json['member_dob'],
    };
}

export function PalAuthSubmissionRemotePatientSearchFieldMapToJSON(json: any): PalAuthSubmissionRemotePatientSearchFieldMap {
    return PalAuthSubmissionRemotePatientSearchFieldMapToJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchFieldMapToJSONTyped(value?: PalAuthSubmissionRemotePatientSearchFieldMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'member_number': value['member_number'],
        'member_last_name': value['member_last_name'],
        'member_first_name': value['member_first_name'],
        'member_dob': value['member_dob'],
    };
}

